// extracted by mini-css-extract-plugin
export default {"checkbox":"TBStatus_checkbox__1S6lw"};